import React from 'react';
import { useCartWishlist } from '../../context/CartWishlistContext';
import { useLanguage } from '../../context/LanguageContext';
import ProductGrid from '../../components/product/ProductGrid';
import UserDashboardShell from '../../components/user/UserDashboardShell';

const Wishlist = () => {
  const { wishlistItems, removeFromWishlist, addToCart } = useCartWishlist();
  const { t } = useLanguage();

  const handleAddToCart = (product) => {
    addToCart(product);
    removeFromWishlist(product.id || product._id);
  };

  if (!Array.isArray(wishlistItems) || wishlistItems.length === 0) {
    return (
      <UserDashboardShell>
        <div className="account-empty-state">
          <h3>{t('wishlist.emptyTitle')}</h3>
          <p>{t('wishlist.emptyText')}</p>
        </div>
      </UserDashboardShell>
    );
  }

  return (
    <UserDashboardShell>
      <section className="account-wishlist">
        <h2 className="account-page__title">{t('wishlist.title', { count: wishlistItems.length })}</h2>
        <ProductGrid
          products={wishlistItems}
          onAddToCart={handleAddToCart}
          onAddToWishlist={(product) => removeFromWishlist(product.id || product._id)}
        />
      </section>
    </UserDashboardShell>
  );
};

export default Wishlist;
